const dam_store = {
    subscribers:{},
    dams: [],
    addDam(dam){
        this.dams.push(dam)
    },
    getDam(dam_id){
        return this.dams.filter(x=>x.id === dam_id)[0]
    },
    getDams(){
        return this.dams
    },
    setDamEvent(dam_id, event){
        console.log('setando');
        this.getDam(dam_id).last_event = event
        this.publish('SET_DAM_EVENT', dam_id)
    },
    setDamEvents(dam_id, events){
        this.getDam(dam_id).events = events
        this.publish('SET_DAM_EVENTS', dam_id)
    },
    setDams(dams){
        this.dams = dams
        this.publish('SET_DAMS', this.dams)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default dam_store